/*
 * Vinn Boutique: stabiele ankerlinks.
 *
 * Twee problemen met Horizon losten we hier op.
 *
 * 1. Shopify rendert elke sectie als <div id="shopify-section-template--123456__mijn_sectie">.
 *    Dat nummer verandert bij elke thema-wissel, dus het is onbruikbaar in een menu.
 *    We hangen bovenaan elke sectie een onzichtbaar ankerpunt met een korte, stabiele naam,
 *    plus een paar leesbare aliassen.
 *
 * 2. Horizon scrollt niet op <html>, maar op .page-wrapper. Omdat html en body op
 *    overflow: hidden staan, doet de browser bij een #hash helemaal niets. We zoeken
 *    daarom zelf de scroll-container en berekenen de positie.
 */
(function () {
  'use strict';

  /* Leesbare naam -> sectiesleutel. Voeg hier gerust aan toe. */
  var ALIASSEN = {
    'voor-horeca': 'media_with_content_dfNnKa',
    'voor-bedrijven': 'media_with_content_EGxdBB',
    'wine-tastings': 'media_with_content_Bp6Xp8',
    'veelgestelde-vragen': 'section_d8tXTX',
    'contact': 'section_cta',
  };

  function maakAnker(sectie, naam) {
    if (!naam || document.getElementById(naam)) return;
    var span = document.createElement('span');
    span.className = 'vinn-anchor';
    span.id = naam;
    span.setAttribute('aria-hidden', 'true');
    sectie.insertBefore(span, sectie.firstChild);
  }

  function plaatsAnkers() {
    var secties = document.querySelectorAll('[id^="shopify-section-"]');
    var perSleutel = {};

    for (var i = 0; i < secties.length; i++) {
      var sectie = secties[i];
      var id = sectie.id.replace('shopify-section-', '');
      var sleutel = id.indexOf('__') !== -1 ? id.split('__').pop() : id;
      perSleutel[sleutel] = sectie;
      maakAnker(sectie, sleutel);
    }

    for (var alias in ALIASSEN) {
      if (!Object.prototype.hasOwnProperty.call(ALIASSEN, alias)) continue;
      var doelSectie = perSleutel[ALIASSEN[alias]];
      if (doelSectie) maakAnker(doelSectie, alias);
    }
  }

  function vindDoel(hash) {
    if (!hash || hash.length < 2) return null;
    var id = decodeURIComponent(hash.slice(1));

    var el = document.getElementById(id);
    if (el) return el;

    var secties = document.querySelectorAll('[id^="shopify-section-"]');
    for (var i = 0; i < secties.length; i++) {
      if (secties[i].id.indexOf(id) !== -1) return secties[i];
    }
    return null;
  }

  /* Horizon scrollt op .page-wrapper, niet op het document. Zoek de echte container. */
  function vindContainer(el) {
    var node = el.parentElement;
    while (node && node !== document.body && node !== document.documentElement) {
      var overflow = window.getComputedStyle(node).overflowY;
      if ((overflow === 'auto' || overflow === 'scroll') && node.scrollHeight > node.clientHeight + 1) {
        return node;
      }
      node = node.parentElement;
    }
    return document.scrollingElement || document.documentElement;
  }

  function offset() {
    var stijl = window.getComputedStyle(document.body);
    var mobiel = window.matchMedia('(max-width: 749px)').matches;
    var naam = mobiel ? '--header-height' : '--header-group-height';
    var waarde = parseFloat(stijl.getPropertyValue(naam));
    if (!waarde || isNaN(waarde)) waarde = parseFloat(stijl.getPropertyValue('--header-height')) || 72;
    return waarde + (mobiel ? 16 : 24);
  }

  function springNaar(doel, vloeiend) {
    if (!doel) return;

    var container = vindContainer(doel);
    var isRoot = container === document.documentElement || container === document.body;
    var doelTop = doel.getBoundingClientRect().top;
    var basis = isRoot ? 0 : container.getBoundingClientRect().top;
    var top = container.scrollTop + doelTop - basis - offset();
    if (top < 0) top = 0;

    var opties = { top: top, behavior: vloeiend ? 'smooth' : 'auto' };
    if (typeof container.scrollTo === 'function') {
      container.scrollTo(opties);
    } else {
      container.scrollTop = top;
    }
  }

  /*
   * Bij binnenkomst met een #hash blijven we even bijsturen. Beelden en lazy secties
   * krijgen pas na de eerste paint hun definitieve hoogte, waardoor een enkele sprong
   * naast de sectie belandt.
   */
  function landOpHash() {
    var hash = window.location.hash;
    if (!hash || hash.length < 2) return;

    if (window.history && 'scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    var start = Date.now();
    var timer = window.setInterval(function () {
      plaatsAnkers();
      springNaar(vindDoel(hash), false);
      if (Date.now() - start > 1800) window.clearInterval(timer);
    }, 120);
  }

  function start() {
    plaatsAnkers();
    landOpHash();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.addEventListener('load', function () {
    plaatsAnkers();
  });

  /* Klik op een ankerlink naar dezelfde pagina. */
  document.addEventListener(
    'click',
    function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      var link = e.target && e.target.closest ? e.target.closest('a[href*="#"]') : null;
      if (!link) return;
      if (link.target && link.target !== '_self') return;

      var url;
      try {
        url = new URL(link.href, window.location.href);
      } catch (err) {
        return;
      }

      if (url.origin !== window.location.origin) return;
      if (url.pathname !== window.location.pathname) return;
      if (!url.hash || url.hash.length < 2) return;

      plaatsAnkers();
      var doel = vindDoel(url.hash);
      if (!doel) return;

      e.preventDefault();
      e.stopPropagation();

      if (window.history && window.history.pushState) {
        window.history.pushState(null, '', url.hash);
      } else {
        window.location.hash = url.hash;
      }

      springNaar(doel, true);
    },
    true
  );

  window.addEventListener('hashchange', function () {
    plaatsAnkers();
    springNaar(vindDoel(window.location.hash), true);
  });
})();
